module.exports = __webpack_public_path__ + "static/img/DE.161cd24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/DE.svg
// module id = FMSA
// module chunks = 66